const Title = ({ text }) => {
  return <h1>{text}</h1>;
};

export default Title;
